"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const checkbox_group_1 = __importDefault(require("../../../client/form_components/inputs/checkbox_group"));
const graphql_1 = require("../../../requests/graphql");
const Form_1 = require("./Form");
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const styles_css_1 = __importDefault(require("./styles.css"));
const dispatchers_1 = require("../../../utility/dispatchers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const time_1 = require("../../../utility/time");
exports.c = {
    container: `${layout_css_1.default.padding30} ${layout_css_1.default.flexRowWrap} ${layout_css_1.default.gutter30}`,
    header: `${util_css_1.default.bgFog} ${util_css_1.default.borderRadiusTopLeftTopRight} ${layout_css_1.default.padding15} ${layout_css_1.default.paddingLeft30} ${typography_css_1.default.h3Responsive} ${layout_css_1.default.flexJustifySpaceBetween}`,
    winnerBox: `${util_css_1.default.border} ${util_css_1.default.borderRadius} ${styles_css_1.default.winnerBox}`,
    userName: `${typography_css_1.default.hackster} ${typography_css_1.default.bodyXLResponsive} ${typography_css_1.default.bold} ${util_css_1.default.borderBottom} ${layout_css_1.default.paddingBottom15}`,
    date: `${typography_css_1.default.bodyS} ${typography_css_1.default.pebble} ${typography_css_1.default.bold}`,
};
const PastWinner = ({ prizes, prizeType, winner }) => {
    const options = prizes.filter(({ prize_type }) => prize_type === prizeType).map(({ name, id }) => ({ label: name, value: id }));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: exports.c.winnerBox },
            react_1.default.createElement("p", { className: exports.c.userName }, winner?.user_name || winner.first_name),
            react_1.default.createElement(checkbox_group_1.default, { classList: { root: layout_css_1.default.margin0 }, disabled: true, label: "Prize Preferences", name: "prize_selection", onChange: () => { }, options: options, values: [winner.prize.id] }),
            winner.registration_type === 'mail_in' && (react_1.default.createElement("div", { className: typography_css_1.default.error },
                "This is a mail-in winner. You will need to email this user at:",
                ' ',
                react_1.default.createElement("span", { className: typography_css_1.default.bold }, winner.email),
                ' ',
                "in order to notify them!"))),
        react_1.default.createElement("div", { className: exports.c.date },
            "Drawn on",
            ' ',
            (0, time_1.timestampToPrettyDate)(winner.created_at))));
};
const Winner = ({ prizeType, setGeneratedWinners, setRemainingPrizes, winner, }) => {
    const { eligible_prizes, prize_preferences } = winner;
    const [selection, setSelection] = (0, react_1.useState)([]);
    const [chosenPrizeId, setChosenPrizeId] = (0, react_1.useState)();
    const seen = new Set();
    const options = [];
    if (prizeType === 'weekly') {
        prize_preferences.forEach((prize) => {
            if (!seen.has(prize.id)) {
                seen.add(prize.id);
                options.push({ label: prize.name, value: prize.id });
            }
        });
        eligible_prizes.forEach((prize) => {
            if (!seen.has(prize.id) && prize.prize_type !== 'grand') {
                seen.add(prize.id);
                options.push({ label: prize.name, value: prize.id });
            }
        });
    }
    else {
        const grandPrizes = eligible_prizes.filter(({ prize_type }) => prize_type === 'grand');
        grandPrizes.forEach((prize) => options.push({ label: prize.name, value: prize.id }));
    }
    const handleAssignPrize = () => {
        // CheckboxGroup component sends back the value as an array -> [undefined, prizeId]
        const prizeId = selection[1];
        (0, graphql_1.graphMutate)({ t: 'create_giveaway_winner' }, {
            prize_id: selection[1],
            registration_id: winner.registration_id,
        })
            .then(({ winner }) => {
            setChosenPrizeId(prizeId);
            setGeneratedWinners((prevState) => prevState.map((w) => w.id === winner.registration_id ? { ...w, prizeAssigned: true } : w));
            setRemainingPrizes(winner?.remaining_prizes || []);
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway assign prize to user: ', err);
            return;
        });
    };
    const handleCancel = () => {
        setGeneratedWinners((prevState) => prevState.filter((w) => w.id !== winner.id));
    };
    return (react_1.default.createElement("div", { className: exports.c.winnerBox },
        react_1.default.createElement("p", { className: exports.c.userName }, winner?.user_name || winner?.first_name),
        react_1.default.createElement(checkbox_group_1.default, { disabled: Boolean(chosenPrizeId), label: "Prize Preferences", name: "prize_selection", onChange: (value) => setSelection(value), options: options, values: chosenPrizeId ? [chosenPrizeId] : [selection] }),
        winner.registration_type === 'mail_in' && (react_1.default.createElement("div", { className: typography_css_1.default.error },
            "This is a mail-in winner. You will need to email this user at:",
            ' ',
            react_1.default.createElement("span", { className: typography_css_1.default.bold }, winner.email),
            ' ',
            "in order to notify them!")),
        react_1.default.createElement("div", { className: `${layout_css_1.default.flexJustifySpaceBetween}` },
            react_1.default.createElement(base_1.default, { colorStyle: "outlineBlue", disabled: selection.length === 0, onClick: handleAssignPrize, size: "sm" }, chosenPrizeId ? 'Assigned' : 'Assign Prize'),
            react_1.default.createElement(base_1.default, { colorStyle: "danger", disabled: chosenPrizeId, onClick: handleCancel, size: "sm" }, "Cancel"))));
};
const Winners = ({ giveawayId, prizes, }) => {
    const [pastWinners, setPastWinners] = (0, react_1.useState)([]);
    const [remainingPrizes, setRemainingPrizes] = (0, react_1.useState)([]);
    const [generatedWinners, setGeneratedWinners] = (0, react_1.useState)([]);
    const hasRemainingWeeklyPrize = remainingPrizes?.some(({ prize_type }) => prize_type === 'weekly');
    const hasRemainingGrandPrize = remainingPrizes?.some(({ prize_type }) => prize_type === 'grand');
    const isWaitingAssignment = generatedWinners?.some(({ prizeAssigned }) => !prizeAssigned);
    const weeklyWinners = [];
    const grandWinners = [];
    generatedWinners.forEach((winner) => winner.prizeType === 'weekly'
        ? weeklyWinners.push(winner)
        : grandWinners.push(winner));
    const weeklyPastWinners = [];
    const grandPastWinners = [];
    pastWinners?.forEach((winner) => winner.prize.prize_type === 'weekly'
        ? weeklyPastWinners.push(winner)
        : grandPastWinners.push(winner));
    const handlePick = ({ target }) => {
        (0, graphql_1.graphQuery)({ t: 'get_giveaway_winner' }, {
            giveaway_id: giveawayId,
            prize_type: target.value,
        })
            .then(({ giveaway_winner }) => {
            if (!giveaway_winner?.id) {
                (0, dispatchers_1.summonGlobalMessenger)({
                    msg: 'There are no registrations / prizes left to giveaway!',
                    type: 'error',
                });
                return;
            }
            setGeneratedWinners((prevState) => [
                ...prevState,
                { ...giveaway_winner, prizeAssigned: false, prizeType: target.value },
            ]);
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway generate winner: ', err);
            return;
        });
    };
    (0, react_1.useEffect)(() => {
        (0, graphql_1.graphQuery)({ t: 'get_giveaway_winners' }, { giveaway_id: giveawayId })
            .then(({ giveaway_winners }) => {
            setPastWinners(giveaway_winners.winners);
            setRemainingPrizes(giveaway_winners.remaining_prizes);
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Giveaway generate winner: ', err);
            return;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("div", { className: exports.c.header },
            react_1.default.createElement("span", null, "Weekly Winners"),
            react_1.default.createElement(base_1.default, { buttonProps: { value: 'weekly' }, disabled: !hasRemainingWeeklyPrize || isWaitingAssignment, onClick: handlePick, size: "md", type: "button" }, "Generate Random Winner")),
        react_1.default.createElement("div", { className: exports.c.container },
            weeklyPastWinners.length > 0
                ? weeklyPastWinners.map((winner) => (react_1.default.createElement(PastWinner, { key: `${winner.user_name}-${winner.email}`, prizeType: "weekly", prizes: prizes, winner: winner })))
                : weeklyWinners.length === 0 && (react_1.default.createElement("div", null, "No winners have been assigned")),
            weeklyWinners.length > 0
                && weeklyWinners.map((winner) => (react_1.default.createElement(Winner, { key: winner.id, prizeType: "weekly", setGeneratedWinners: setGeneratedWinners, setRemainingPrizes: setRemainingPrizes, winner: winner })))),
        react_1.default.createElement("div", { className: exports.c.header },
            react_1.default.createElement("span", null, "Grand Prize Winner"),
            react_1.default.createElement(base_1.default, { buttonProps: { value: 'grand' }, disabled: !hasRemainingGrandPrize || isWaitingAssignment, onClick: handlePick, size: "md", type: "button" }, "Generate Grand Prize Winner")),
        react_1.default.createElement("div", { className: exports.c.container },
            grandPastWinners.length > 0
                ? grandPastWinners.map((winner) => (react_1.default.createElement(PastWinner, { key: `${winner.user_name}-${winner.email}`, prizeType: "grand", prizes: prizes, winner: winner })))
                : grandWinners.length === 0 && (react_1.default.createElement("div", null, "No winners have been assigned")),
            grandWinners.length > 0
                && grandWinners.map((winner) => (react_1.default.createElement(Winner, { key: winner.id, prizeType: "grand", setGeneratedWinners: setGeneratedWinners, setRemainingPrizes: setRemainingPrizes, winner: winner }))))));
};
exports.default = Winners;
